import script from "./AppAsessment.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAsessment.vue?vue&type=script&setup=true&lang=js"

import "./AppAsessment.vue?vue&type=style&index=0&id=f235eb00&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f235eb00"]])

export default __exports__